import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const CustomSelect = ({
  options,
  defaultValue,
  placeholder = "Select an option",
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(defaultValue || "");

  const selectedOption = options.find(
    (option) => option.id === selectedValue
  );

  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsOpen(false);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="relative w-full">
      {/* Select Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full bg-grey-700 hover:bg-grey-600 text-white px-4 py-3 rounded-lg border border-grey-600 flex items-center justify-between transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      >
        <span className="text-left">
          {selectedOption ? selectedOption.name : placeholder}
        </span>
        <ChevronDown
          className={`w-5 h-5 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-slate-700 border border-slate-600 rounded-lg shadow-lg z-50 overflow-hidden">
          {options.map((option) => (
            <button
              key={option.id}
              onClick={() => handleSelect(option.id)}
              className="w-full px-4 py-3 text-left hover:bg-slate-600 text-white transition-colors duration-150 flex flex-col border-b border-slate-600 last:border-b-0"
            >
              <span className="font-medium">{option.name}</span>
              {option.description && (
                <span className="text-sm text-gray-400 mt-1">
                  {option.description}
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
